// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2251":"c7a96faf","4094":"7974cf3c"}[chunkId] + ".chunk.css";
};